import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { VendorService } from '@/api/services/masterService';

interface VendorMaster {
  vendorTypeId: string;
  id: string;
  vendorName: string;
}

interface VendorMasterState {
  VendorMasterlist: VendorMaster[];
  filteredLists: {
    [key: string]: VendorMaster[];
  };
  loading: boolean;
  error: string | undefined;
}

const initialState: VendorMasterState = {
  VendorMasterlist: [],
  filteredLists: {},
  loading: false,
  error: undefined,
};

export const fetchVendorMaster = createAsyncThunk(
  'VendorMaster/fetchVendorMaster',
  async (_, { rejectWithValue }) => {
    try {
      const response = await VendorService.getall();
      return response.data ? response.data : response;
    } catch (error: any) {
      return rejectWithValue(error?.message || 'Failed to fetch common masters');
    }
  }
);

// Create the slice
const VendorMasterSlice = createSlice({
  name: 'VendorMaster',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchVendorMaster.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchVendorMaster.fulfilled, (state, action) => {
        state.VendorMasterlist = action.payload;
        // Filter lists dynamically by vendorTypeIdId
        const filterTypes = ["01JMBWNGQ691K6KJSV6VYVSSM5","01JNR5MGE9P3X626NN4555KJHC","01JPCQ9T1JSBZ0EYBENS21BFMP5","01JPCQ9T1JSBZ0EYBENS21BFMP6"];
        state.filteredLists = filterTypes?.reduce((acc, filterType) => {
          acc[filterType] = action.payload?.filter(
            (item: VendorMaster) => item.vendorTypeId === filterType
          );
          return acc;
        }, {} as { [key: string]: VendorMaster[] });
        state.loading = false;
      })
      .addCase(fetchVendorMaster.rejected, (state, action) => {
        state.loading = false;
        state.error = typeof action.payload === 'string' ? action.payload : 'Unknown error occurred';
      });
  },
});

// Export the reducer
export default VendorMasterSlice.reducer;

